module.exports = __webpack_public_path__ + "static/media/door0101.87cf7e9d.jpg";